import React from 'react';
import {  View, Text, StyleSheet, TouchableOpacity } from 'react-native';
import { Modal } from '@material-ui/core';
const IDVerificationModal = ({ visible, onClose, onStart ,data}) => {
    console.log("IDVerificationModal",data)

  return (
    <Modal
      transparent={true}
      open={visible}
      animationType="slide"
      onRequestClose={onClose}
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        paddingLeft: 10,
        paddingRight: 10,
     
      }}
    >
      <View style={styles.overlay}>
        <View style={styles.modalContainer}>
          <Text style={styles.title}>ID Verification for {data?.app_user?.user?.first_name?data?.app_user?.user?.first_name:"" } {data?.app_user?.user?.last_name?data?.app_user?.user?.last_name:"" }</Text>

          <Text style={styles.info}>
            In order to fulfil your 'Right to Rent' checks, please select the tenants you would like to have ID Verified.
          </Text>

          <Text style={styles.cost}>Cost: £ 0</Text>

          <View style={styles.buttonRow}>
            <TouchableOpacity style={styles.cancelButton} onPress={onClose}>
              <Text style={styles.cancelText}>Cancel</Text>
            </TouchableOpacity>

            <TouchableOpacity
              style={styles.startButton}
              onPress={() => {
                onStart();
                onClose();
              }}
            >
              <Text style={styles.startText}>Start</Text>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    </Modal>
  );
};

export default IDVerificationModal;

const styles = StyleSheet.create({
  overlay: {
    backgroundColor: '#fff',
    borderRadius: 10,
    shadowColor: '#000',
    shadowOpacity: 0.1,
    shadowOffset: { width: 0, height: 2 },
    shadowRadius: 4,
    elevation: 3,
    width:"50%",
  },
  modalContainer: {
    backgroundColor: '#fff',
    borderRadius: 12,
    padding: 20,
    elevation: 10,
  },
  title: {
    fontSize: 18,
    fontWeight: '600',
    marginBottom: 15,
  },
  info: {
    fontSize: 14,
    color: '#333',
    marginBottom: 15,
  },
  cost: {
    fontWeight: '500',
    marginBottom: 20,
  },
  buttonRow: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  cancelButton: {
    paddingVertical: 10,
    paddingHorizontal: 20,
    marginRight: 10,
    borderColor: '#999',
    borderWidth: 1,
    borderRadius: 8,
  },
  startButton: {
    paddingVertical: 10,
    paddingHorizontal: 20,
    backgroundColor: '#1976d2',
    borderRadius: 8,
  },
  cancelText: {
    color: '#555',
    fontWeight: '500',
  },
  startText: {
    color: '#fff',
    fontWeight: '600',
  },
});
